import * as React from 'react';
import { RecoilRoot } from 'recoil';
import { BoardCellAtomFamily, CurrentBoardAtom, GoalHintsAtom, HistoryAtom, HistoryStepNumberAtom, MetaMatrixAtom, WorkingBoardAtom } from '../utils/context';
import { generateHints } from '../utils/hints';
import { Matrix, MetaMatrix } from '../utils/Matrix';
import { GameController } from './GameController';
function RecoilNonogramGrid(_a) {
    var rows = _a.rows, cols = _a.cols, solution = _a.solution, init = _a.init, _b = _a.onRefresh, onRefresh = _b === void 0 ? function () { } : _b;
    var solutionMatrix = React.useMemo(function () {
        return new Matrix(solution.map(function (elem) {
            if (typeof elem === 'boolean') {
                return elem ? 'filled' : 'marked';
            }
            else {
                return elem;
            }
        }), new MetaMatrix(rows, cols));
    }, [solution]);
    var initMatrix = React.useMemo(function () {
        return init
            ? new Matrix(init, new MetaMatrix(rows, cols))
            : undefined;
    }, [init]);
    var initializeState = React.useCallback(function (_a) {
        var set = _a.set;
        var metaMatrix = solutionMatrix.metaMatrix;
        set(MetaMatrixAtom, metaMatrix);
        var realInit = initMatrix !== null && initMatrix !== void 0 ? initMatrix : Matrix.init(metaMatrix, 'empty');
        metaMatrix.all().forEach(function (location) {
            var _a;
            set(BoardCellAtomFamily(location.index), (_a = realInit.at(location.index)) !== null && _a !== void 0 ? _a : 'marked');
        });
        set(CurrentBoardAtom, realInit);
        set(WorkingBoardAtom, realInit);
        var history = [realInit];
        set(HistoryAtom, history);
        set(HistoryStepNumberAtom, 0);
        set(GoalHintsAtom, generateHints(solutionMatrix));
    }, [init, solution]);
    return (React.createElement("div", { key: (solutionMatrix === null || solutionMatrix === void 0 ? void 0 : solutionMatrix.toString()) + "_" + (initMatrix === null || initMatrix === void 0 ? void 0 : initMatrix.toString()) },
        React.createElement(RecoilRoot, { initializeState: initializeState },
            React.createElement(GameController, { onRefresh: onRefresh }))));
}
export var NonogramGrid = React.memo(RecoilNonogramGrid, function (prev, next) {
    return (prev.onRefresh === next.onRefresh &&
        prev.solution === next.solution &&
        prev.init === next.init);
});
